import { render, staticRenderFns } from "./addchannel.vue?vue&type=template&id=0bafa5f8&"
import script from "./addchannel.vue?vue&type=script&lang=js&"
export * from "./addchannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bafa5f8')) {
      api.createRecord('0bafa5f8', component.options)
    } else {
      api.reload('0bafa5f8', component.options)
    }
    module.hot.accept("./addchannel.vue?vue&type=template&id=0bafa5f8&", function () {
      api.rerender('0bafa5f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/addchannel.vue"
export default component.exports